<div class="row mb-0-cust pt-4">
  <div class="col-12">
    <mat-label
      >{{ message }}:
      <a [href]="termsUrl" class="text-decoration-underline"
        >{{ 'admin.global.termsOfUse' | translate }}
      </a>
      ,
      <a [href]="privacyUrl" class="text-decoration-underline"
        >{{ 'admin.global.privacyPolicy' | translate }}.
      </a>
    </mat-label>
  </div>
</div>
